import { DashboardModuleListItem } from '@domain-group/suit-theme'

import useGeoSuburb, { useRelations } from '@hooks/useGeoSuburb'

import type { GeoSuburbModel } from '@models/types'

const GeoSuburbListItem = (props: { geoSuburb: GeoSuburbModel }) => {
  const { geoSuburb, geoSuburb: { title, post_code } } = props

  const geoSuburbPayload = useGeoSuburb(geoSuburb)
  const {
    callbacks: { createOrEditSuburb },
  } = geoSuburbPayload

  const { geoState } = useRelations(geoSuburb)

  return (
    <DashboardModuleListItem
      onClick={() => createOrEditSuburb()}
      secondaryText={post_code}
      title={title}
    >
      {/*
       // @ts-expect-error TS2339 */}
      <DashboardModuleListItem.TertiaryText>
        {geoState.title}
        {/*
       // @ts-expect-error TS2339 */}
      </DashboardModuleListItem.TertiaryText>
    </DashboardModuleListItem>
  )
}

export default GeoSuburbListItem
